// extracted by mini-css-extract-plugin
export default {"logo":"questionnaire_logo__VxKnn","main":"questionnaire_main__kwuN-","message":"questionnaire_message__P+VOG","line":"questionnaire_line__kujtK"};